import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe2c7d5e")

_pushScopeId("data-v-fe2c7d5e")
const _hoisted_1 = { class: "canvas__container" }
const _hoisted_2 = { class: "series__container scrollbar--invisible" }
const _hoisted_3 = { class: "container__info" }
const _hoisted_4 = { class: "container__pool" }
const _hoisted_5 = { class: "span__pool" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", {
  class: "icon-attention-circled",
  title: "Match non-homologué"
}, null, -1)
const _hoisted_8 = { class: "container__time" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "container__team"
}
const _hoisted_13 = { class: "container__divider" }
const _hoisted_14 = {
  key: 0,
  class: "container__trophy"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-trophy" }, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 4,
  class: "container__team"
}
const _hoisted_18 = { class: "container__edits" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-sketch" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "icon-upload" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "icon-trash" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheScheduleTable = _resolveComponent("TheScheduleTable")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "table__title",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDiagram && _ctx.toggleDiagram(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.division) + " ", 1),
      _createVNode("i", {
        class: {
                'icon-angle-down': !_ctx.collapsed,
                'icon-angle-right': _ctx.collapsed
              }
      }, null, 2)
    ]),
    _createVNode("div", _hoisted_2, [
      (_ctx.hasRoundRobinMatchup)
        ? (_openBlock(), _createBlock(_component_TheScheduleTable, {
            key: 0,
            filterSetName: _ctx.filterSetName,
            style: {
                    'display': _ctx.collapsed? 'none': 'block'
                }
          }, null, 8, ["filterSetName", "style"]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: "series_diagram",
        style: {
                'width': _ctx.width+'px',
                'height': _ctx.height+'px',
                'position': 'relative',
                'display': _ctx.collapsed? 'none': 'block'
            }
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.seriesMatchup, (obj, ix) => {
          return (_openBlock(), _createBlock("div", {
            key: ix,
            style: {'top': `calc(${obj.y}px - 2em)`, 'left': obj.x+'px', 'position': 'absolute'},
            class: {'contain': _ctx.xInterval < 250}
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(obj.series.pool), 1),
                (obj.series.field)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: ["span__field", {'narrow': _ctx.xInterval < 150}]
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/fields#${encodeURI(obj.series.field)}`
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(obj.series.field), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.awaitingApproval(obj.series))
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_8, [
                (obj.series.date)
                  ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.dateStr(obj.series.date)), 1))
                  : _createCommentVNode("", true),
                (obj.series.date)
                  ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.timeStr(obj.series.date)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!!obj.series.homeTeam)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: [{
                            'container__team--light': (obj.series.result?.homeTeam ?? 0) < (obj.series.result?.awayTeam ?? 0)
                        }, "container__team"]
                }, [
                  _createVNode(_component_TeamLabel, {
                    team: _ctx.teamInfo[obj.series.homeTeam]
                  }, null, 8, ["team"]),
                  (obj.series.result && !_ctx.isEditing(obj.series))
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("span", {
                          class: ["container__score", {
                                    'container__score--bold': (obj.series.result?.homeTeam ?? 0) > (obj.series.result?.awayTeam ?? 0)
                                }]
                        }, _toDisplayString(obj.series.result.homeTeam), 3)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isEditing(obj.series))
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.homeTeamScore = $event)),
                        type: "number",
                        min: "0",
                        max: "99",
                        step: "1"
                      }, null, 512)), [
                        [_vModelText, _ctx.homeTeamScore]
                      ])
                    : _createCommentVNode("", true)
                ], 2))
              : (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode(_component_TeamLabel, {
                    badge: false,
                    alt: _ctx.altTeam(obj.series.homeDivision, obj.series.homePool, obj.series.homeRank)
                  }, null, 8, ["alt"])
                ])),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", {
                class: "series__divider--horizontal",
                style: `width:${_ctx.xInterval}px;`
              }, null, 4),
              (!obj.child)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true)
            ]),
            (obj.child)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "series__divider--vertical",
                  style: `height:${_ctx.verticalDividerHeight(obj)}px; top: ${_ctx.verticalDividerTop(obj)}; left: ${_ctx.xInterval}px; position: absolute`
                }, null, 4))
              : _createCommentVNode("", true),
            (obj.series.awayTeam)
              ? (_openBlock(), _createBlock("div", {
                  key: 3,
                  class: [{
                            'container__team--light': (obj.series.result?.awayTeam ?? 0) < (obj.series.result?.homeTeam ?? 0)
                        }, "container__team"]
                }, [
                  _createVNode(_component_TeamLabel, {
                    team: _ctx.teamInfo[obj.series.awayTeam]
                  }, null, 8, ["team"]),
                  (obj.series.result && !_ctx.isEditing(obj.series))
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("span", {
                          class: ["container__score", {
                                    'container__score--bold': (obj.series.result?.awayTeam ?? 0) > (obj.series.result?.homeTeam ?? 0)
                                }]
                        }, _toDisplayString(obj.series.result.awayTeam), 3)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isEditing(obj.series))
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.awayTeamScore = $event)),
                        type: "number",
                        min: "0",
                        max: "99",
                        step: "1"
                      }, null, 512)), [
                        [_vModelText, _ctx.awayTeamScore]
                      ])
                    : _createCommentVNode("", true)
                ], 2))
              : (_openBlock(), _createBlock("div", _hoisted_17, [
                  _createVNode(_component_TeamLabel, {
                    badge: false,
                    alt: _ctx.altTeam(obj.series.awayDivision, obj.series.awayPool, obj.series.awayRank)
                  }, null, 8, ["alt"])
                ])),
            _createVNode("div", _hoisted_18, [
              (_ctx.canEditResults(obj.series))
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.edit(obj.series))
                  }, [
                    _hoisted_19
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditing(obj.series))
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.update(obj.series))
                  }, [
                    _hoisted_20
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditing(obj.series))
                ? (_openBlock(), _createBlock("div", {
                    key: 2,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                  }, [
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isEditing(obj.series) && _ctx.canApproveMatchResult(obj.series))
                ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                    key: 3,
                    type: "ok",
                    onConfirm: ($event: any) => (_ctx.approveMatch(obj.series._id))
                  }, null, 8, ["onConfirm"]))
                : _createCommentVNode("", true)
            ])
          ], 6))
        }), 128))
      ], 4)
    ])
  ]))
})